import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { get } from "lodash";

import { Field, FieldError, FieldLabel } from "@/components/ui/field";
import ColorPicker from "components/ColorPicker";

import { REQUIRED_MARK } from "./fieldClasses";

const FormColorPicker = ({ name, label, required, disabled, preview }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, name);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Field data-invalid={error ? true : undefined}>
          {label && (
            <FieldLabel className={required ? REQUIRED_MARK : undefined}>
              {label}
            </FieldLabel>
          )}
          <div>
            <ColorPicker
              color={field.value}
              setColor={disabled ? undefined : field.onChange}
            >
              {preview}
            </ColorPicker>
          </div>
          <FieldError>{error?.message}</FieldError>
        </Field>
      )}
    />
  );
};

FormColorPicker.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.node,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  preview: PropTypes.node,
};

export default FormColorPicker;
